/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
'use strict';

function normalizePayload(operation, payload) {
  var data = payload.data,
      errors = payload.errors;

  if (data != null) {
    return require("./normalizeRelayPayload")(operation.root, data, errors, {
      handleStrippedNulls: true
    });
  }

  var node = operation.node;

  var error = require("./RelayError").create('RelayNetwork', 'No data returned for operation `%s`, got error(s):\n%s\n\nSee the error ' + '`source` property for more information.', node.params ? node.params.name : node.name, errors ? errors.map(function (_ref) {
    var message = _ref.message;
    return message;
  }).join('\n') : '(No errors)');

  error.source = {
    errors: errors,
    operation: operation.node,
    variables: operation.variables
  };
  throw error;
}

module.exports = normalizePayload;